<template>
	<div>
		<div class="colhead">
			<h2 class="header_h2">预约分类管理</h2>
		</div>
		<el-header>
			<el-button type="primary" style="margin:10px 5px 0px 10px;float: left;" @click="baonewAdd">新增</el-button>
			<el-input v-model="select_word" placeholder="分类名称过滤查找"
				style="display:inline-block;width:350px;float: left;"></el-input>
		
		</el-header>
		<el-main>
			
			<el-table border ref="multipleTable" tooltip-effect="dark" :data="data.slice((currentPage-1)*pagesize,currentPage*pagesize)">
				<el-table-column prop="isvalid" label="启用" width="60px">
					<template slot-scope="scope">
						<li v-if='scope.row.isvalid=="0"'>禁用</li>
						<li v-if='scope.row.isvalid=="1"'>启用</li>
					</template>
				</el-table-column>
				<el-table-column prop="type_name" label="分类名称" width="200px"></el-table-column>
				<el-table-column prop="timestep" label="时间段"></el-table-column>
				<el-table-column prop="is_special_item" label="特殊项目">
					<template slot-scope="scope1">
						<li v-if='scope1.row.is_special_item=="0"'>否</li>
						<li v-if='scope1.row.is_special_item=="1"'>是</li>
					</template>
				</el-table-column>
				<el-table-column prop="memo" label="备注"></el-table-column>
				<el-table-column label="操作" width="100px" fixed="right">
					<template slot-scope="scope2">
						<el-button @click="handleEdit(scope2.$index, scope2.row)" icon="el-icon-edit" type="text" size="small">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- </el-container> -->
			<el-footer style="margin-top:20px;">
				<template>
					<div class="block">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
						 :page-sizes="[5, 10, 20, 40]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="data.length"></el-pagination>
					</div>
				</template>
			</el-footer>
		</el-main>
		<!-- 修改信息 -->
		<el-dialog title="修改信息" :visible.sync="bao1edit">
			<el-form :model="EditInfo" ref="EditInfo" label-width="100px">
				<el-form-item label="启用">
					<el-switch v-model="EditInfo.isvalid" active-value="1" inactive-value="0"></el-switch>
				</el-form-item>
				<el-form-item label="分类名称">
					<el-input v-model="EditInfo.type_name"></el-input>
				</el-form-item>
				<el-form-item label="时间段">
					<el-select v-model="EditInfo.timestep" placeholder="请选择" style="width: 100%;" filterable allow-create>
						<el-option v-for="item in emBookTimeStep" :label="item.key" :value="item.key">{{ item.key }}</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="特殊项目">
					<el-switch v-model="EditInfo.is_special_item" active-value="1" inactive-value="0"></el-switch>
				</el-form-item>
				<el-form-item label="特殊项目映射ID">
					<el-input v-model="EditInfo.map_itemid"></el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input v-model="EditInfo.memo"></el-input>
				</el-form-item>

				<!-- 按钮确定和取消 -->
				<el-form-item>
					<el-button type="primary" @click.native="bao1editSure">确定</el-button>
					<el-button @click.native="bao1edit = false">取消</el-button>
				</el-form-item>
			</el-form>

		</el-dialog>

		<!-- ----新增信息---- -->
		<el-dialog title="新增信息" :visible.sync="bao1newadd">
			<el-form :model="AddInfo" ref="AddInfo" label-width="100px">
				<el-form-item label="启用">
					<el-switch v-model="AddInfo.isvalid" active-value="1" inactive-value="0"></el-switch>
				</el-form-item>
				<el-form-item label="分类名称">
					<el-input v-model="AddInfo.type_name"></el-input>
				</el-form-item>
				<el-form-item label="时间段">
					<el-select v-model="AddInfo.timestep" placeholder="请选择" style="width: 100%;" filterable allow-create>
						<el-option v-for="item in emBookTimeStep" :label="item.key" :value="item.key">{{ item.key }}</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="特殊项目">
					<el-switch v-model="AddInfo.is_special_item" active-value="1" inactive-value="0"></el-switch>
				</el-form-item>
				<el-form-item label="特殊项目映射ID">
					<el-input v-model="AddInfo.map_itemid"></el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input v-model="AddInfo.memo"></el-input>
				</el-form-item>
				<!-- 按钮确定和取消 -->
				<el-form-item>
					<el-button type="primary" @click.native="bao1AddSure">确定</el-button>
					<el-button @click.native="bao1newadd = false">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>



<script>
	// import enums from '../../commontools/enums.js'
	import booktype from '../../apifunction/Book.js'
	export default {
		
		data() {
			return {
				BookTypeData: [],
				emBookTimeStep: this.$enums.BookTimeStep,
				currentPage: 1,
				pagesize: 10,
				bao1edit: false,
				bao1newadd: false,
				idx: null,
				//   通过姓名查询
				select_word: "",
				EditInfo: {
					book_type_id: '',
					type_name: '',
					timestep: '',
					memo: '',
					is_special_item: '0',
					map_itemid: '',
					isvalid: '1'
				},
				AddInfo: {
					book_type_id: '',
					type_name: '',
					timestep: '',
					memo: '',
					is_special_item: '0',
					map_itemid: '',
					isvalid: '1'
				}
			}
		},
		mounted() {
			this.GetBookTypeAll();
		},
		methods: {
			//   得到所有的数据---------------
			GetBookTypeAll() {
				booktype.GetBookTypeAll()
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.BookTypeData = JSON.parse(ent.Data);

						} else
							this.$message.info(ent.Msg);
					})
			},
			// 分页------------------------
			// 初始页currentPage、初始每页数据数pagesize和数据data
			handleSizeChange: function(size) {
				this.pagesize = size;
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
			},
			// 操作界面 ----------- 编辑-----通过改变数据并且驱动视图更新$set方法
			handleEdit(index, row) {
				this.idx = index;
				this.bao1edit = true;

				this.EditInfo = {
					book_type_id: row.book_type_id,
					type_name: row.type_name,
					timestep: row.timestep,
					memo: row.memo,
					is_special_item: row.is_special_item,
					map_itemid: row.map_itemid,
					isvalid: row.isvalid
				};
			},
			// 操作界面 ----------- 编辑 -------确定按钮
			bao1editSure() {
				booktype.EditBookType(this.EditInfo)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.BookTypeData.splice(this.idx, 1, this.EditInfo)
							this.bao1edit = false;
							this.$message.success("修改成功");

						} else
							this.$message.info(ent.Msg);
					})

			},
			// 新增按钮-----
			baonewAdd() {
				this.bao1newadd = true;
				this.AddInfo.book_type_id = '';
				this.AddInfo.type_name = '';
				this.AddInfo.timestep = '';
				this.AddInfo.is_special_item = '0';
				this.AddInfo.map_itemid = '';
				this.AddInfo.isvalid = '1';
				this.AddInfo.memo = '';
			},
			// 新增按钮----- 新增 ----确定按钮
			bao1AddSure() {
				//this.$refs.AddInfo 这个数据上有一个validate方法,这个方法可以判断数据是否存在
				if (this.AddInfo.type_name == '') {
					this.$message.success("名称不能为空！");
					return;
				}
				this.AddInfo.book_type_id = this.CommonFun.NewGuid();

				booktype.AddBookType(this.AddInfo)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.data.unshift(this.AddInfo);
							this.bao1newadd = false;
							this.$message.success("新增成功");

						} else
							this.$message.info(ent.Msg);
					})
			},
		},
		computed: {
			data() {
				return this.BookTypeData.filter(item => {

					if (item.type_name.indexOf(this.select_word) > -1) {
						return item;
					}
				});
			}
		}
	};
</script>



